import { ReferenceFormAccessor } from 'types'

export const viewOnlyFields = Object.values(ReferenceFormAccessor)
